export default __webpack_public_path__ + "static/media/Shop.62530798.svg";